import React, { useEffect, useState } from "react";
import AdminSectionHeader from "@/components/admin/AdminSectionHeader";
import AdminTable from "@/components/admin/AdminTable";
import { api, formatApiError } from "@/lib/api";
import { StatusBadge } from "@/components/app/StatusBadge";

export default function AdminUsers() {
    const [users, setUsers] = useState([]);
    const [error, setError] = useState("");
    useEffect(() => {
        api.get("/admin/users", { params: { limit: 200 } })
            .then(({ data }) => setUsers(data))
            .catch((e) => setError(formatApiError(e)));
    }, []);
    return (
        <>
            <AdminSectionHeader title="Utilisateurs" description="Comptes publics (acheteurs / vendeurs). Le compte admin est séparé." />
            {error && <div className="mb-4 rounded-lg border border-md-danger/30 bg-md-danger/10 px-4 py-2 text-sm text-md-danger">{error}</div>}
            <AdminTable
                columns={[
                    { key: "pseudo", label: "Pseudo" },
                    { key: "email", label: "Email" },
                    { key: "roles", label: "Rôles", render: (r) => (
                        <div className="flex flex-wrap gap-1">
                            {(r.roles || []).map((role) => (
                                <StatusBadge key={role} tone={role === "buyer" ? "primary" : "gold"}>{role}</StatusBadge>
                            ))}
                        </div>
                    )},
                    { key: "seller_status", label: "Onboarding", render: (r) => r.seller_status || "—" },
                    { key: "created_at", label: "Créé", render: (r) => r.created_at?.split("T")[0] || "—" },
                ]}
                rows={users}
                emptyLabel="Aucun utilisateur pour l’instant."
            />
        </>
    );
}
